import classnames from "classnames";
import { FiFileText } from "react-icons/fi";

// Generic button template that builds on the CoreUI button component.
const Button = ({
  active,
  block,
  color,
  children,
  className,
  disabled,
  iconClassName,
  iconName,
  onClick,
  pressed,
  shape,
  size = "sm",
  title,
  type = "button",
  variant,
  ...rest
}) => {
  return (
    <div
      active={active}
      aria-disabled={disabled}
      block={block}
      color={color}
      className={classnames(
        { [className]: Boolean(className) },
        "d-inline-flex align-items-center btn button"
      )} // Only add the class if the prop has been set, otherwise leave it out.
      disabled={disabled}
      onClick={onClick}
      pressed={pressed}
      size={size}
      shape={shape}
      title={title}
      type={type}
      variant={variant}
      {...rest}
    >
      {iconName ? (
        <FiFileText
          className={classnames(
            { [iconClassName]: Boolean(iconClassName) },
            { "mr-2": Boolean(children) },
            "p-0 my-0"
          )}
        />
      ) : null}
      {children || null}
    </div>
  );
};

export default Button;
